import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { applySavedTheme } from './hooks/useTheme'
import './i18n'

applySavedTheme()

createRoot(document.getElementById('root')!).render(
  <App />,
)
